<template>
  <div class="form-message" :class="variant">
    {{ message }}
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  name: "FormMessage",
  props: {
    errors: [String, Array],
    variant: {
      type: String,
      default: "danger",
    },
  },
  setup(props) {
    const message = computed(() => {
      if (Array.isArray(props.errors)) {
        return props.errors.join(" - ");
      }
      return props.errors;
    });

    return { message };
  },
};
</script>

<style lang="scss" scoped>
.form-message {
  display: block;
  font-size: 0.75rem;
  text-align: center;
  padding: 0.5rem 1rem;
  margin-bottom: 1.5rem;
}
</style>
